import { Content } from '@phrasee/phrasee-typings'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { errorToast } from 'common/components/toastNotification'
import { useAppDispatch, useAppSelector } from 'common/hooks/redux'
import { getSelectedElement } from 'features/unifiedFlow/contentPage/helpers'
import { selectElement } from 'features/unifiedFlow/store/unifiedFlowSlice'

import { deleteElement } from '../api'
import { contentKeys } from '../queryKeys'

const useDeleteElementMutation = () => {
  const dispatch = useAppDispatch()
  const queryClient = useQueryClient()
  const selectedElementId = useAppSelector(
    (state) => state.unifiedFlow.selectedElementId
  )

  return useMutation({
    mutationFn: deleteElement,
    onError: () => {
      errorToast('Something went wrong. Please try again.')
    },
    onSuccess: (content: Content, { elementId: deteledElementId }) => {
      const selectedElement = getSelectedElement(content)
      const contentId = content._id

      queryClient.setQueryData(contentKeys.content(contentId), content)

      if (selectedElementId === deteledElementId) {
        dispatch(
          selectElement({
            elementId: selectedElement?.element_id,
          })
        )
      }
    },
  })
}

export default useDeleteElementMutation
